import React from "react"
import { cn } from "../styles/utils"
import { type PropsWithClassname } from "../types"
import { Pressable } from "./Pressable"
import { Text } from "./Text"

interface TextLinkProps extends PropsWithClassname {
  children: React.ReactNode
  onPress: () => void
  disabled?: boolean
  size?: "xs" | "sm" | "md" | "lg"
  textClassName?: string
  hitSlop?: { top: number; bottom: number; left: number; right: number }
}

export const TextLink: React.FC<TextLinkProps> = ({
  children,
  onPress,
  disabled = false,
  size = "sm",
  className,
  textClassName,
  hitSlop,
}) => {
  const getSizeClass = () => {
    switch (size) {
      case "xs":
        return "text-xs"
      case "sm":
        return "text-sm"
      case "md":
        return "text-base"
      case "lg":
        return "text-lg"
      default:
        return "text-sm"
    }
  }

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      className={cn("p-1", className)}
      hitSlop={hitSlop}
    >
      <Text
        className={cn(
          getSizeClass(),
          "text-primary-600 underline select-none",
          disabled && "opacity-50",
          textClassName,
        )}
      >
        {children}
      </Text>
    </Pressable>
  )
}
